import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutNavigationComponent } from '@shared/components/layouts/layout-navigation/layout-navigation.component';

@Component({
  selector: 'app-layout-dashboard',
  imports: [RouterOutlet, LayoutNavigationComponent],
  templateUrl: './layout-dashboard.html',
  styleUrl: './layout-dashboard.scss',
})
export class LayoutDashboard {}
